"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { Paintbrush } from "lucide-react";
import { useMemo } from "react";

// export function PickerExample() {
//   const [background, setBackground] = useState("#B4D455");

//   return (
//     <div
//       className="w-full h-full preview flex min-h-[350px] justify-center p-10 items-center rounded !bg-cover !bg-center transition-all"
//       style={{ background }}
//     >
//       <GradientPicker background={background} setBackground={setBackground} />
//     </div>
//  );
// }

export function GradientPicker({
  background,
  setBackground,
  type,
  className,
}: {
  background: string;
  setBackground: (background: string) => void;
  type: "solid" | "gradient" | "url" | "all" | "gradient&url"| "gradient&solid";
  className?: string;
}) {
  const solids = [
    "rgb(9, 30, 58) ",
    "rgb(148, 0, 211) ",
    "rgb(200, 78, 137) ",
    "rgb(0, 245, 160) ",
    "rgb(247, 148, 30) ",
    "rgb(114, 198, 239) ",
    "rgb(253, 129, 18) ",
    "rgb(191, 90, 224) ",
    "rgb(251, 237, 150) ",
    "rgb(255, 224, 0) ",
    "rgb(247, 248, 248) ",
    "rgb(0, 65, 106) ",
    "rgb(51, 77, 80) ",
    "rgb(0, 82, 212) ",
    "rgb(84, 51, 255) ",
    "rgb(121, 159, 12) ",
    "rgb(255, 226, 89) ",
    "rgb(172, 182, 229) ",
    "rgb(83, 105, 118) ",
    "rgb(183, 152, 145) ",
    "rgb(151, 150, 240) ",
    "rgb(187, 210, 197) ",
    "rgb(7, 101, 133) ",
    "rgb(0, 70, 127) ",
    "rgb(0, 12, 64) ",
    "rgb(20, 136, 204) ",
    "rgb(236, 0, 140) ",
    "rgb(204, 43, 94) ",
    "rgb(230, 92, 0) ",
    "rgb(43, 88, 118) ",
    "rgb(49, 71, 85) ",
    "rgb(119, 161, 211) ",
    "rgb(255, 110, 127) ",
    "rgb(229, 45, 39) ",
    "rgb(96, 56, 19) ",
    "rgb(22, 160, 133) ",
    "rgb(211, 16, 39) ",
    "rgb(237, 229, 116) ",
    "rgb(2, 170, 176) ",
    "rgb(218, 34, 255) ",
    "rgb(52, 143, 80) ",
    "rgb(60, 165, 92) ",
    "rgb(204, 149, 192) ",
    "rgb(0, 57, 115) ",
    "rgb(229, 93, 135) ",
    "rgb(64, 59, 74) ",
    "rgb(240, 152, 25) ",
    "rgb(255, 81, 47) ",
    "rgb(170, 7, 107) ",
    "rgb(26, 41, 128) ",
    "rgb(29, 43, 100) ",
    "rgb(31, 162, 255) ",
    "rgb(76, 184, 196) ",
    "rgb(221, 94, 137) ",
    "rgb(235, 51, 73) ",
    "rgb(29, 151, 108) ",
    "rgb(255, 128, 8) ",
    "rgb(22, 34, 42) ",
    "rgb(31, 28, 44) ",
    "rgb(97, 67, 133) ",
    "rgb(71, 118, 230) ",
    "rgb(8, 80, 120) ",
    "rgb(43, 192, 228) ",
    "rgb(19, 78, 94) ",
    "rgb(92, 37, 141) ",
    "rgb(117, 127, 154) ",
    "rgb(35, 37, 38) ",
    "rgb(28, 216, 210) ",
    "rgb(61, 126, 170) ",
    "rgb(40, 48, 72) ",
    "rgb(36, 198, 220) ",
    "rgb(220, 36, 36) ",
    "rgb(237, 66, 100) ",
    "rgb(218, 226, 248) ",
    "rgb(236, 233, 230) ",
    "rgb(116, 116, 191) ",
    "rgb(236, 111, 102) ",
    "rgb(95, 44, 130) ",
    "rgb(192, 72, 72) ",
    "rgb(228, 58, 21) ",
    "rgb(65, 77, 11) ",
    "rgb(252, 53, 76) ",
    "rgb(75, 108, 183) ",
    "rgb(248, 87, 166) ",
    "rgb(167, 55, 55) ",
    "rgb(213, 51, 105) ",
    "rgb(233, 211, 98) ",
    "rgb(222, 98, 98) ",
    "rgb(102, 102, 0) ",
    "rgb(255, 238, 238) ",
    "rgb(239, 239, 187) ",
    "rgb(194, 21, 0) ",
    "rgb(33, 95, 0) ",
    "rgb(80, 201, 195) ",
    "rgb(221, 214, 243) ",
    "rgb(93, 65, 87) ",
    "rgb(230, 218, 218) ",
    "rgb(242, 112, 156) ",
    "rgb(218, 210, 153) ",
    "rgb(211, 149, 155) ",
    "rgb(0, 210, 255) ",
    "rgb(135, 0, 0) ",
    "rgb(185, 147, 214) ",
    "rgb(100, 145, 115) ",
    "rgb(201, 255, 191) ",
    "rgb(96, 108, 136) ",
    "rgb(251, 211, 233) ",
    "rgb(173, 209, 0) ",
    "rgb(255, 78, 80) ",
    "rgb(240, 194, 123) ",
    "rgb(0, 0, 0) ",
    "rgb(170, 255, 169) ",
    "rgb(179, 255, 171) ",
    "rgb(120, 2, 6) ",
    "rgb(157, 80, 187) ",
    "rgb(85, 98, 112) ",
    "rgb(112, 225, 245) ",
    "rgb(0, 198, 255) ",
    "rgb(254, 140, 0) ",
    "rgb(82, 194, 52) ",
    "rgb(72, 85, 99) ",
    "rgb(131, 164, 212) ",
    "rgb(253, 252, 71) ",
    "rgb(171, 186, 171) ",
    "rgb(115, 200, 169) ",
    "rgb(211, 131, 18) ",
    "rgb(30, 19, 12) ",
    "rgb(148, 142, 153) ",
    "rgb(54, 0, 51) ",
    "rgb(255, 161, 127) ",
    "rgb(67, 206, 162) ",
    "rgb(255, 179, 71) ",
    "rgb(100, 65, 165) ",
    "rgb(254, 172, 94) ",
    "rgb(131, 58, 180) ",
    "rgb(255, 0, 132) ",
    "rgb(0, 191, 143) ",
    "rgb(19, 106, 138) ",
    "rgb(142, 158, 171) ",
    "rgb(123, 67, 151) ",
    "rgb(209, 145, 60) ",
    "rgb(241, 242, 181) ",
    "rgb(106, 145, 19) ",
    "rgb(0, 79, 249) ",
    "rgb(82, 82, 82) ",
    "rgb(186, 139, 2) ",
    "rgb(48, 67, 82) ",
    "rgb(204, 204, 178) ",
    "rgb(44, 62, 80) ",
    "rgb(252, 0, 255) ",
    "rgb(229, 57, 53) ",
    "rgb(0, 92, 151) ",
    "rgb(244, 107, 69) ",
    "rgb(0, 201, 255) ",
    "rgb(103, 58, 183) ",
    "rgb(118, 184, 82) ",
    "rgb(142, 14, 0) ",
    "rgb(255, 183, 94) ",
    "rgb(194, 229, 156) ",
    "rgb(64, 58, 62) ",
    "rgb(192, 36, 37) ",
    "rgb(178, 69, 146) ",
    "rgb(69, 127, 202) ",
    "rgb(106, 48, 147) ",
    "rgb(234, 205, 163) ",
    "rgb(253, 116, 108) ",
    "rgb(17, 67, 87) ",
    "rgb(30, 60, 114) ",
    "rgb(47, 115, 54) ",
    "rgb(86, 20, 176) ",
    "rgb(77, 160, 176) ",
    "rgb(90, 63, 55) ",
    "rgb(41, 128, 185) ",
    "rgb(0, 153, 247) ",
    "rgb(131, 77, 155) ",
    "rgb(75, 121, 161) ",
    "rgb(76, 161, 175) ",
    "rgb(224, 234, 252) ",
    "rgb(186, 83, 112) ",
    "rgb(255, 75, 31) ",
    "rgb(247, 255, 0) ",
    "rgb(168, 0, 119) ",
    "rgb(29, 67, 80) ",
    "rgb(238, 205, 163) ",
    "rgb(22, 191, 253) ",
    "rgb(255, 95, 109) ",
    "rgb(33, 150, 243) ",
    "rgb(58, 123, 213) ",
    "rgb(11, 72, 107) ",
    "rgb(233, 100, 67) ",
    "rgb(44, 62, 80) ",
    "rgb(240, 0, 0) ",
    "rgb(20, 30, 48) ",
    "rgb(66, 39, 90) ",
    "rgb(0, 4, 40) ",
    "rgb(86, 171, 47) ",
    "rgb(203, 45, 62) ",
    "rgb(247, 157, 0) ",
    "rgb(248, 80, 50) ",
    "rgb(252, 234, 187) ",
    "rgb(128, 128, 128) ",
    "rgb(255, 216, 155) ",
    "rgb(189, 195, 199) ",
    "rgb(190, 147, 197) ",
    "rgb(161, 255, 206) ",
    "rgb(78, 205, 196) ",
    "rgb(58, 97, 134) ",
    "rgb(239, 50, 217) ",
    "rgb(222, 97, 97) ",
    "rgb(255, 0, 204) ",
    "rgb(255, 252, 0) ",
    "rgb(255, 126, 95) ",
    "rgb(0, 195, 255) ",
    "rgb(244, 196, 243) ",
    "rgb(65, 41, 90) ",
    "rgb(167, 112, 239) ",
    "rgb(238, 9, 121) ",
    "rgb(243, 144, 79) ",
    "rgb(103, 178, 111) ",
    "rgb(52, 148, 230) ",
    "rgb(219, 230, 246) ",
    "rgb(156, 236, 251) ",
    "rgb(192, 192, 170) ",
    "rgb(220, 227, 91) ",
    "rgb(232, 203, 192) ",
    "rgb(240, 242, 240) ",
    "rgb(255, 175, 189) ",
    "rgb(67, 198, 172) ",
    "rgb(9, 48, 40) ",
    "rgb(69, 104, 220) ",
    "rgb(5, 117, 230) ",
    "rgb(32, 1, 34) ",
    "rgb(68, 160, 141) ",
    "rgb(97, 144, 232) ",
    "rgb(52, 232, 158) ",
    "rgb(247, 151, 30) ",
    "rgb(195, 55, 100) ",
    "rgb(32, 0, 44) ",
    "rgb(214, 109, 117) ",
    "rgb(48, 232, 191) ",
    "rgb(178, 254, 250) ",
    "rgb(74, 194, 154) ",
    "rgb(228, 77, 38) ",
    "rgb(235, 87, 87) ",
    "rgb(242, 153, 74) ",
    "rgb(86, 204, 242) ",
    "rgb(0, 121, 145) ",
    "rgb(0, 0, 70) ",
    "rgb(21, 153, 87) ",
    "rgb(192, 57, 43) ",
    "rgb(239, 59, 54) ",
    "rgb(40, 60, 134) ",
    "rgb(58, 28, 113) ",
    "rgb(203, 53, 107) ",
    "rgb(54, 209, 220) ",
    "rgb(28, 146, 210) ",
    "rgb(100, 43, 115) ",
    "rgb(6, 190, 182) ",
    "rgb(12, 235, 235) ",
    "rgb(217, 167, 199) ",
    "rgb(57, 106, 252) ",
    "rgb(201, 214, 255) ",
    "rgb(127, 0, 255) ",
    "rgb(255, 153, 102) ",
    "rgb(34, 193, 195) ",
    "rgb(26, 42, 108) ",
    "rgb(225, 238, 195) ",
    "rgb(173, 169, 150) ",
    "rgb(102, 125, 182) ",
    "rgb(3, 0, 30) ",
    "rgb(109, 96, 39) ",
    "rgb(116, 235, 213) ",
    "rgb(252, 74, 26) ",
    "rgb(0, 242, 96) ",
    "rgb(128, 0, 128) ",
    "rgb(202, 197, 49) ",
    "rgb(60, 59, 63) ",
    "rgb(211, 204, 227) ",
    "rgb(0, 176, 155) ",
    "rgb(15, 12, 41) ",
    "rgb(255, 251, 213) ",
    "rgb(35, 7, 77) ",
    "rgb(201, 75, 75) ",
    "rgb(252, 70, 107) ",
    "rgb(252, 92, 125) ",
    "rgb(16, 141, 199) ",
    "rgb(17, 153, 142) ",
    "rgb(62, 81, 81) ",
    "rgb(64, 224, 208) ",
    "rgb(188, 78, 156) ",
    "rgb(53, 92, 125) ",
    "rgb(78, 84, 200) ",
    "rgb(51, 51, 51) ",
    "rgb(168, 192, 255) ",
    "rgb(173, 83, 137) ",
    "rgb(99, 99, 99) ",
    "rgb(218, 68, 83) ",
    "rgb(0, 90, 167) ",
    "rgb(89, 193, 115) ",
    "rgb(255, 239, 186) ",
    "rgb(0, 180, 219) ",
    "rgb(253, 200, 48) ",
    "rgb(237, 33, 58) ",
    "rgb(30, 150, 0) ",
    "rgb(168, 255, 120) ",
    "rgb(138, 35, 135) ",
    "rgb(255, 65, 108) ",
    "rgb(101, 78, 163) ",
    "rgb(0, 159, 255) ",
    "rgb(84, 74, 125) ",
    "rgb(131, 96, 195) ",
    "rgb(221, 62, 84) ",
    "rgb(101, 153, 153) ",
    "rgb(241, 39, 17) ",
    "rgb(195, 20, 50) ",
    "rgb(127, 127, 213) ",
    "rgb(249, 83, 198) ",
    "rgb(31, 64, 55) ",
    "rgb(142, 45, 226) ",
    "rgb(170, 75, 107) ",
    "rgb(255, 0, 153) ",
    "rgb(41, 128, 185) ",
    "rgb(55, 59, 68) ",
    "rgb(185, 43, 39) ",
    "rgb(18, 194, 233) ",
    "rgb(15, 32, 39) ",
    "rgb(198, 255, 221) ",
    "rgb(33, 147, 176) ",
    "rgb(238, 156, 167) ",
    "rgb(243, 98, 34) ",
    "rgb(42, 45, 62) ",
    "rgb(138, 43, 226) ",
    "rgb(5, 25, 55) ",
    "rgb(96, 37, 245) ",
    "rgb(39, 116, 174) ",
    "rgb(0, 70, 128) ",
    "rgb(126, 198, 188) ",
    "rgb(255, 30, 86) ",
    "rgb(222, 138, 65) ",
    "rgb(247, 240, 172) ",
    "rgb(255, 0, 0) ",
    "rgb(54, 177, 199) ",
    "rgb(29, 161, 242) ",
    "rgb(109, 166, 190) ",
    "rgb(181, 185, 255) ",
    "rgb(159, 160, 168) ",
    "rgb(220, 255, 189) ",
    "rgb(139, 222, 218) ",
    "rgb(230, 174, 140) ",
    "rgb(0, 255, 240) ",
    "rgb(12, 12, 109) ",
    "rgb(5, 56, 107) ",
    "rgb(66, 132, 219) ",
    "rgb(85, 64, 35) ",
    "rgb(81, 107, 139) ",
    "rgb(215, 6, 82) ",
    "rgb(21, 35, 49) ",
    "rgb(247, 247, 247) ",
    "rgb(89, 205, 233) ",
    "rgb(235, 0, 0) ",
    "rgb(255, 117, 195) ",
    "rgb(129, 255, 138) ",
    "rgb(212, 252, 121) ",
    "rgb(0, 61, 77) ",
    "rgb(255, 154, 158) ",
    "rgb(161, 140, 209) ",
    "rgb(250, 208, 196) ",
    "rgb(255, 236, 210) ",
    "rgb(255, 129, 119) ",
    "rgb(246, 211, 101) ",
    "rgb(251, 194, 235) ",
    "rgb(253, 203, 241) ",
    "rgb(161, 196, 253) ",
    "rgb(132, 250, 176) ",
    "rgb(207, 217, 223) ",
    "rgb(166, 192, 254) ",
    "rgb(252, 203, 144) ",
    "rgb(224, 195, 252) ",
    "rgb(240, 147, 251) ",
    "rgb(253, 251, 251) ",
    "rgb(79, 172, 254) ",
    "rgb(67, 233, 123) ",
    "rgb(250, 112, 154) ",
    "rgb(48, 207, 208) ",
    "rgb(168, 237, 234) ",
    "rgb(94, 231, 223) ",
    "rgb(210, 153, 194) ",
    "rgb(245, 247, 250) ",
    "rgb(22, 217, 227) ",
    "rgb(102, 126, 234) ",
    "rgb(253, 252, 251) ",
    "rgb(137, 247, 254) ",
    "rgb(253, 219, 146) ",
    "rgb(152, 144, 227) ",
    "rgb(235, 192, 253) ",
    "rgb(150, 251, 196) ",
    "rgb(42, 245, 152) ",
    "rgb(205, 156, 242) ",
    "rgb(228, 175, 203) ",
    "rgb(184, 203, 184) ",
    "rgb(106, 17, 203) ",
    "rgb(55, 236, 186) ",
    "rgb(235, 187, 167) ",
    "rgb(255, 241, 235) ",
    "rgb(238, 162, 162) ",
    "rgb(196, 113, 245) ",
    "rgb(72, 198, 239) ",
    "rgb(247, 140, 160) ",
    "rgb(254, 173, 166) ",
    "rgb(230, 233, 240) ",
    "rgb(172, 203, 238) ",
    "rgb(233, 222, 250) ",
    "rgb(193, 223, 196) ",
    "rgb(11, 163, 96) ",
    "rgb(0, 198, 251) ",
    "rgb(106, 133, 182) ",
    "rgb(163, 189, 237) ",
    "rgb(151, 149, 240) ",
    "rgb(167, 166, 203) ",
    "rgb(63, 81, 177) ",
    "rgb(252, 197, 228) ",
    "rgb(219, 220, 215) ",
    "rgb(244, 59, 71) ",
    "rgb(79, 181, 118) ",
    "rgb(2, 80, 197) ",
    "rgb(136, 211, 206) ",
    "rgb(217, 175, 217) ",
    "rgb(112, 40, 228) ",
    "rgb(19, 84, 122) ",
    "rgb(189, 187, 190) ",
    "rgb(80, 82, 133) ",
    "rgb(255, 8, 68) ",
    "rgb(67, 67, 67) ",
    "rgb(12, 52, 131) ",
    "rgb(147, 165, 207) ",
    "rgb(146, 254, 157) ",
    "rgb(255, 117, 140) ",
    "rgb(134, 143, 150) ",
    "rgb(199, 144, 129) ",
    "rgb(139, 170, 170) ",
    "rgb(248, 54, 0) ",
    "rgb(183, 33, 255) ",
    "rgb(110, 69, 226) ",
    "rgb(213, 88, 200) ",
    "rgb(171, 236, 214) ",
    "rgb(213, 212, 208) ",
    "rgb(95, 114, 189) ",
    "rgb(9, 32, 63) ",
    "rgb(220, 176, 237) ",
    "rgb(243, 231, 233) ",
    "rgb(199, 29, 111) ",
    "rgb(150, 222, 218) ",
    "rgb(247, 112, 98) ",
    "rgb(196, 197, 199) ",
    "rgb(168, 202, 186) ",
    "rgb(41, 50, 60) ",
    "rgb(22, 160, 133) ",
    "rgb(255, 88, 88) ",
    "rgb(0, 205, 172) ",
    "rgb(188, 197, 206) ",
    "rgb(68, 129, 235) ",
    "rgb(218, 212, 236) ",
    "rgb(135, 77, 162) ",
    "rgb(232, 25, 139) ",
    "rgb(234, 223, 223) ",
    "rgb(247, 148, 164) ",
    "rgb(100, 179, 244) ",
    "rgb(59, 65, 197) ",
    "rgb(15, 216, 80) ",
    "rgb(211, 211, 211) ",
    "rgb(58, 181, 176) ",
    "rgb(32, 156, 255) ",
    "rgb(189, 194, 232) ",
    "rgb(230, 185, 128) ",
    "rgb(213, 222, 231) ",
    "rgb(155, 225, 93) ",
    "rgb(237, 110, 160) ",
    "rgb(255, 195, 160) ",
    "rgb(204, 32, 142) ",
    "rgb(179, 255, 171) ",
    "rgb(213, 222, 231) ",
    "rgb(101, 189, 96) ",
    "rgb(36, 57, 73) ",
    "rgb(252, 96, 118) ",
    "rgb(223, 233, 243) ",
    "rgb(0, 219, 222) ",
    "rgb(249, 212, 35) ",
    "rgb(80, 204, 127) ",
    "rgb(10, 207, 254) ",
    "rgb(97, 97, 97) ",
    "rgb(61, 51, 147) ",
    "rgb(223, 137, 181) ",
    "rgb(215, 210, 204) ",
    "rgb(225, 79, 173) ",
    "rgb(178, 36, 239) ",
    "rgb(193, 193, 97) ",
    "rgb(236, 119, 171) ",
    "rgb(0, 122, 223) ",
    "rgb(32, 226, 215) ",
    "rgb(44, 216, 213) ",
    "rgb(223, 255, 205) ",
    "rgb(93, 159, 255) ",
    "rgb(168, 191, 255) ",
    "rgb(82, 113, 196) ",
    "rgb(255, 226, 159) ",
    "rgb(34, 225, 255) ",
    "rgb(182, 206, 232) ",
    "rgb(255, 254, 255) ",
    "rgb(227, 253, 245) ",
    "rgb(125, 226, 252) ",
    "rgb(203, 186, 204) ",
    "rgb(183, 248, 219) ",
    "rgb(112, 133, 182) ",
    "rgb(119, 255, 210) ",
    "rgb(172, 50, 228) ",
    "rgb(212, 255, 236) ",
    "rgb(158, 251, 211) ",
    "rgb(71, 59, 123) ",
    "rgb(101, 55, 155) ",
    "rgb(164, 69, 178) ",
    "rgb(119, 66, 178) ",
    "rgb(255, 60, 172) ",
    "rgb(255, 5, 124) ",
    "rgb(105, 234, 203) ",
    "rgb(35, 21, 87) ",
    "rgb(61, 78, 129)",
  ];

  const gradients = [
    "linear-gradient(to top left, #091e3a, #2f80ed, #2d9ee0)",
    "linear-gradient(to top left, #f7941e, #72c6ef, #00a651)",
    "linear-gradient(to top left, #00416a, #799f0c, #ffe000)",
    "linear-gradient(to top left, #0052d4, #4364f7, #6fb1fc)",
    "linear-gradient(to top left, #5433ff, #20bdff, #a5fecb)",
    "linear-gradient(to top left, #77a1d3, #79cbca, #e684ae)",
    "linear-gradient(to top left, #cc95c0, #dbd4b4, #7aa1d2)",
    "linear-gradient(to top left, #1fa2ff, #12d8fa, #a6ffcb)",
    "linear-gradient(to top left, #feac5e, #c779d0, #4bc0c8)",
    "linear-gradient(to top left, #833ab4, #fd1d1d, #fcb045)",
    "linear-gradient(to top left, #a770ef, #cf8bf3, #fdb99b)",
    "linear-gradient(to top left, #9cecfb, #65c7f7, #0052d4)",
    "linear-gradient(to top left, #3a1c71, #d76d77, #ffaf7b)",
    "linear-gradient(to top left, #0cebeb, #20e3b2, #29ffc6)",
    "linear-gradient(to top left, #1a2a6c, #b21f1f, #fdbb2d)",
    "linear-gradient(to top left, #ada996, #f2f2f2, #dbdbdb, #eaeaea)",
    "linear-gradient(to top left, #667db6, #0082c8, #0082c8, #667db6)",
    "linear-gradient(to top left, #03001e, #7303c0, #ec38bc, #fdeff9)",
    "linear-gradient(to top left, #0f0c29, #302b63, #24243e)",
    "linear-gradient(to top left, #40e0d0, #ff8c00, #ff0080)",
    "linear-gradient(to top left, #355c7d, #6c5b7b, #c06c84)",
    "linear-gradient(to top left, #59c173, #a17fe0, #5d26c1)",
    "linear-gradient(to top left, #1e9600, #fff200, #ff0000)",
    "linear-gradient(to top left, #8a2387, #e94057, #f27121)",
    "linear-gradient(to top left, #7f7fd5, #86a8e7, #91eae4)",
    "linear-gradient(to top left, #aa4b6b, #6b6b83, #3b8d99)",
    "linear-gradient(to top left, #2980b9, #6dd5fa, #ffffff)",
    "linear-gradient(to top left, #12c2e9, #c471ed, #f64f59)",
    "linear-gradient(to top left, #0f2027, #203a43, #2c5364)",
    "linear-gradient(to top left, #c6ffdd, #fbd786, #f7797d)",
    "linear-gradient(to top left, #f36222, #5cb644, #007fc3)",
    "linear-gradient(to top left, #8a2be2, #0000cd, #228b22, #ccff00)",
    "linear-gradient(to top left, #051937, #004d7a, #008793, #00bf72, #a8eb12)",
    "linear-gradient(to top left, #8a2be2, #ffa500, #f8f8ff)",
    "linear-gradient(to top left, #2774ae, #002e5d, #002e5d)",
    "linear-gradient(to top left, #ff1e56, #f9c942, #1e90ff)",
    "linear-gradient(to top left, #f7f0ac, #acf7f0, #f0acf7)",
    "linear-gradient(to top left, #6da6be, #4b859e, #6da6be)",
    "linear-gradient(to top left, #8bdeda, #43ADD0, #998EE0, #E17DC2, #EF9393)",
    "linear-gradient(to top left, #333333, #a2ab58, #a43931)",
    "linear-gradient(to top left, #0c0c6d, #de512b, #98d0c1, #5bb226, #023c0d)",
    "linear-gradient(to top left, #f7f7f7, #b9a0a0, #794747, #4e2020, #111111)",
    "linear-gradient(to top left, #eb0000, #95008a, #3300fc)",
    "linear-gradient(to top left, #ff75c3, #ffa647, #ffe83f, #9fff5b, #70e2ff, #cd93ff)",
    "linear-gradient(to top left, #ff9a9e, #fad0c4, #fad0c4)",
    "linear-gradient(to top left, #fad0c4, #fad0c4, #ffd1ff)",
    "linear-gradient(to top left, #ff8177, #ff867a, #ff8c7f, #f99185, #cf556c, #b12a5b)",
    "linear-gradient(to top left, #ff9a9e, #fecfef, #fecfef)",
    "linear-gradient(to top left, #fdcbf1, #fdcbf1, #e6dee9)",
    "linear-gradient(to top left, #16d9e3, #30c7ec, #46aef7)",
    "linear-gradient(to top left, #e4afcb, #b8cbb8, #b8cbb8, #e2c58b, #c2ce9c, #7edbdc)",
    "linear-gradient(to top left, #b8cbb8, #b8cbb8, #b465da, #cf6cc9, #ee609c, #ee609c)",
    "linear-gradient(to top left, #eea2a2, #bbc1bf, #57c6e1)",
    "linear-gradient(to top left, #f78ca0, #f9748f, #fd868c)",
    "linear-gradient(to top left, #a7a6cb, #8989ba, #8989ba)",
    "linear-gradient(to top left, #3f51b1, #5a55ae, #7b5fac, #8f6aae, #a86aa4, #cc6b8e, #f18271, #f3a469, #f7c978)",
    "linear-gradient(to top left, #fcc5e4, #fda34b, #ff7882, #c8699e, #7046aa, #0c1db8, #020f75)",
    "linear-gradient(to top left, #dbdcd7, #dddcd7, #e2c9cc, #e7627d, #b8235a, #801357, #3d1635, #1c1a27)",
    "linear-gradient(to top left, #4fb576, #44c489, #28a9ae, #28a2b7, #4c7788, #6c4f63, #432c39)",
    "linear-gradient(to top left, #505285, #585e92, #65689f)",
    "linear-gradient(to top left, #0c3483, #a2b6df, #6b8cce)",
    "linear-gradient(to top left, #d5d4d0, #d5d4d0, #eeeeec)",
    "linear-gradient(to top left, #ddd6f3, #faaca8, #faaca8)",
    "linear-gradient(to top left, #f3e7e9, #e3eeff, #e3eeff)",
    "linear-gradient(to top left, #c4c5c7, #dcdddf, #ebebeb)",
    "linear-gradient(to top left, #dad4ec, #dad4ec, #f3e7e9)",
    "linear-gradient(to top left, #3b41c5, #a981bb, #ffc8a9)",
    "linear-gradient(to top left, #d3d3d3, #d3d3d3, #e0e0e0)",
    "linear-gradient(to top left, #3ab5b0, #3d99be, #56317a)",
    "linear-gradient(to top left, #bdc2e8, #bdc2e8, #e6dee9)",
    "linear-gradient(to top left, #1e3c72, #1e3c72, #2a5298)",
    "linear-gradient(to top left, #d5dee7, #ffafbd, #c9ffbf)",
    "linear-gradient(to top left, #d5dee7, #e8ebf2, #e2e7ed)",
    "linear-gradient(to top left, #65bd60, #5ac1a8, #3ec6ed)",
    "linear-gradient(to top left, #3d3393, #2b76b9, #2cacd1, #35eb93           )",
    "linear-gradient(to top left, #c1c161, #c1c161, #d4d4b1)",
    "linear-gradient(to top left, #2cd8d5, #c5c1ff, #ffbac3)",
    "linear-gradient(to top left, #2cd8d5, #6b8dd6, #8e37d7)",
    "linear-gradient(to top left, #dfffcd, #90f9c4, #39f3bb)",
    "linear-gradient(to top left, #5d9fff, #b8dcff, #6bbbff)",
    "linear-gradient(to top left, #5271c4, #b19fff, #eca1fe)",
    "linear-gradient(to top left, #ffe29f, #ffa99f, #ff719a)",
    "linear-gradient(to top left, #22e1ff, #1d8fe1, #625eb1)",
    "linear-gradient(to top left, #7085b6, #87a7d9, #def3f8)",
    "linear-gradient(to top left, #77ffd2, #6297db, #1eecff)",
    "linear-gradient(to top left, #ac32e4, #7918f2, #4801ff)",
    "linear-gradient(to top left, #d4ffec, #57f2cc, #4596fb)",
    "linear-gradient(to top left, #9efbd3, #57e9f2, #45d4fb)",
    "linear-gradient(to top left, #473b7b, #3584a7, #30d2be)",
    "linear-gradient(to top left, #65379b, #886aea, #6457c6)",
    "linear-gradient(to top left, #a445b2, #d41872, #ff0066)",
    "linear-gradient(to top left, #7742b2, #f180ff, #fd8bd9)",
    "linear-gradient(to top left, #ff3cac, #562b7c, #2b86c5)",
    "linear-gradient(to top left, #ff057c, #8d0b93, #321575)",
    "linear-gradient(to top left, #ff057c, #7c64d5, #4cc3ff)",
    "linear-gradient(to top left, #69eacb, #eaccf8, #6654f1)",
    "linear-gradient(to top left, #231557, #44107a, #ff1361)",
    "linear-gradient(to top left, #3d4e81, #5753c9, #6e7ff3)",
  ];

  const images = [
    "url(/backgrounds/aare.svg)",

    "url(/backgrounds/aberrant-01.jpeg",
    "url(/backgrounds/ethereal-02.jpeg",
    "url(/backgrounds/gauze-08.jpeg",
    "url(/backgrounds/twilight-08.jpeg",
    "url(/backgrounds/aberrant-08.jpeg",
    "url(/backgrounds/ethereal-11.jpeg",
    "url(/backgrounds/iridescent-06.jpeg",
    "url(/backgrounds/umbra-06.jpeg",
    "url(/backgrounds/dispersion-04.jpeg",
    "url(/backgrounds/fusion-01.jpeg",
    "url(/backgrounds/metallic-04.jpeg",
    "url(/backgrounds/dispersion-09.jpeg",
    "url(/backgrounds/fusion-05.jpeg",
    "url(/backgrounds/roseate-02.jpeg",
    "url(/backgrounds/dispersion-11.jpeg",
    "url(/backgrounds/gauze-01.jpeg",
    "url(/backgrounds/roseate-11.jpeg",

    "url(/backgrounds/aare.svg)",
    "url(/backgrounds/doubs.svg)",
    "url(/backgrounds/clarence.svg)",
    "url(/backgrounds/inn.svg)",
    "url(/backgrounds/kander.svg)",
    "url(/backgrounds/mataura.svg)",
    "url(/backgrounds/mohaka.svg)",
    "url(/backgrounds/linth.svg)",
    "url(/backgrounds/rangitikei.svg)",
    "url(/backgrounds/reuss.svg)",
    "url(/backgrounds/rhône.svg)",
    "url(/backgrounds/taieri.svg)",
    "url(/backgrounds/thur.svg)",
    "url(/backgrounds/vorderrhein.svg)",
    "url(/backgrounds/waiau.svg)",
    "url(/backgrounds/waihou.svg)",
    "url(/backgrounds/waimakariri.svg)",
    "url(/backgrounds/wairau.svg)",
    "url(/backgrounds/whangaehu.svg)",
    "url(/backgrounds/ngaruroro.svg)",
    "url(/backgrounds/oreti.svg)",
    "url(/backgrounds/hinterrhein.svg)",

    "url(/backgrounds/abstract-timekeeper.svg)",
    "url(/backgrounds/bermuda-traingle.svg)",
    "url(/backgrounds/bullseye-gradient.svg)",
    "url(/backgrounds/colorful-stingrays.svg)",
    "url(/backgrounds/confetti-doodles.svg)",
    "url(/backgrounds/dalmatian-spots.svg)",
    "url(/backgrounds/flat-mountains.svg)",
    "url(/backgrounds/glass-aurora-001.jpg)",
    "url(/backgrounds/glass-aurora-002.jpg)",
    "url(/backgrounds/gloss-pink.jpg)",
    "url(/backgrounds/hollowed-boxes.svg)",
    "url(/backgrounds/liquid-cheese.svg)",
    "url(/backgrounds/nature-009.jpg)",
    "url(/backgrounds/nature-011.jpg)",
    "url(/backgrounds/nature-016.jpg)",
    "url(/backgrounds/nature-024.jpg)",
    "url(/backgrounds/polka-dots.svg)",
    "url(/backgrounds/protruding-squares.svg)",
    "url(/backgrounds/quantum-gradient.svg)",
    "url(/backgrounds/radiant-gradient.svg)",
    "url(/backgrounds/rainbow-vortex.svg)",

    "url(/backgrounds/spectrum-gradient.svg)",

    "url(/backgrounds/wintery-sunburst.svg)",
  ];

  const defaultTab = useMemo(() => {
    if (type?.includes("gradient")) return "gradient";
    if (type?.includes("url")) return "image";
    if (type?.includes("solid")) return "solid";
    return "gradient";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [background]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "max-w-full justify-start text-left p-3 overflow-hidden",
            !background && "text-muted-foreground",
            className,
          )}
        >
          <div className="relative flex items-center w-full gap-2">
            {background ? (
              <div
                className="h-4 w-4 rounded !bg-center !bg-cover transition-all"
                style={{ background }}
              ></div>
            ) : (
              <Paintbrush className="w-4 h-4" />
            )}
            <div className=" max-w-32">
              {background ? background : "Pick a color"}
            </div>
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[300px] p-2">
        <Tabs defaultValue={defaultTab} className="w-full ">
          {["all", "gradient&url"].includes(type) && (
            <TabsList className="w-full mb-4">
              {["all", "solid"].includes(type) && (
                <TabsTrigger className="flex-1" value="solid">
                  Solid
                </TabsTrigger>
              )}
              <TabsTrigger className="flex-1" value="gradient">
                Gradient
              </TabsTrigger>
              <TabsTrigger className="flex-1" value="image">
                Image
              </TabsTrigger>
            </TabsList>
          )}

          <TabsContent
            value="solid"
            className="flex flex-wrap gap-1 mt-0 overflow-y-scroll max-h-52"
          >
            {solids.map((s) => (
              <div
                key={s}
                style={{ background: s }}
                className="w-6 h-6 rounded-md cursor-pointer active:scale-105"
                onClick={() => setBackground(s)}
              />
            ))}
          </TabsContent>

          <TabsContent
            value="gradient"
            className="mt-0 overflow-y-scroll max-h-52 "
          >
            <div className="flex flex-wrap gap-1 mb-2">
              {gradients.map((s) => (
                <div
                  key={s}
                  style={{ background: s }}
                  className="w-6 h-6 rounded-md cursor-pointer active:scale-105"
                  onClick={() => setBackground(s)}
                />
              ))}
            </div>

            {/* <GradientButton background={background}>
              💡 Get more at{' '}
              <Link
                href="https://gradient.page/css/ui-gradients"
                className="font-bold hover:underline"
                target="_blank"
              >
                Gradient Page
              </Link>
            </GradientButton> */}
          </TabsContent>

          <TabsContent
            value="image"
            className="mt-0 overflow-y-scroll max-h-52 "
          >
            <div className="grid grid-cols-2 gap-1 mb-2">
              {images.map((s) => (
                <div
                  key={s}
                  style={{ backgroundImage: s }}
                  className="w-full h-12 bg-center bg-cover rounded-md cursor-pointer active:scale-105"
                  onClick={() => setBackground(s)}
                />
              ))}
            </div>

            {/* <GradientButton background={background}>
              🎁 Get abstract{' '}
              <Link
                href="https://gradient.page/wallpapers"
                className="font-bold hover:underline"
                target="_blank"
              >
                wallpapers
              </Link>
            </GradientButton> */}
          </TabsContent>
        </Tabs>

        <Input
          id="custom"
          value={background}
          className="h-8 col-span-2 mt-2"
          onChange={(e) => setBackground(e.currentTarget.value)}
        />
      </PopoverContent>
    </Popover>
  );
}

// const GradientButton = ({
//   background,
//   children,
// }: {
//   background: string;
//   children: React.ReactNode;
// }) => {
//   return (
//     <div
//       className="p-0.5 rounded-md relative !bg-cover !bg-center transition-all"
//       style={{ background }}
//     >
//       <div className="p-1 text-xs text-center rounded-md bg-popover/80">
//         {children}
//       </div>
//     </div>
//  );
// };
